import React, { useState, useEffect } from "react";
import './ViewProjectContractor.css';
import { useNavigate, useParams } from 'react-router-dom';
import ProjectAPIs from "../../../../../../../MasonyFixingsAPIs/ProjectAPIs/ProjectAPIs";
import DropDown from "../../../../../../DropDown/DropDown";
import ViewProjectContractorEmployee from "./ViewProjectContractorEmployee/ViewProjectContractorEmployee";
import { AiFillEdit } from "react-icons/ai";
import { MdCancel, MdEdit } from "react-icons/md";
import { FaChevronDown, FaChevronUp, FaSave } from "react-icons/fa";
import { Collapse, Form } from "react-bootstrap";
import CompanyAPIs from "../../../../../../../MasonyFixingsAPIs/CompanyAPIs/CompanyAPIs";
import ApiResponseHandler from "../../../../../../../MasonyFixingsAPIs/ApiResponseHandler";
import { useToast } from "../../../../../../../Contexts/ToastContext";

export default function ViewProjectContractor(){

    const { addToast } = useToast();
    const params = useParams();
    const navigate = useNavigate();

    const [loading, setLoading] = useState(true);
    const [editing, setEditing] = useState(false);
    const [sending, setSending] = useState(false);
    const [showEmployees, setShowEmployees] = useState(false);
    const [showAcc, setShowAcc] = useState(false);
    const [employees, setEmployees] = useState([]);

    const [contractorData, setContractorData] = useState({});
    const [mainContractorID, setMainContractorID] = useState();
    const [accContactID, setAccContactID] = useState();
    const [foremanID, setForemanID] = useState();
    const [sftyOffID, setSftyOffID] = useState();
    const [storemanID, setStoremanID] = useState();

   

    const getProjectContractorData = (projectID) => {
        ProjectAPIs.GetProjectMainContractor(projectID)
        .then((response) => {
            setContractorData(response.data);
            setMainContractorID(response.data?.company?.id ?? '');
            setAccContactID(response.data?.accountContact?.id ?? '');
            setForemanID(response.data?.foreman?.id ?? '');
            setSftyOffID(response.data?.safetyOfficer?.id ?? '');
            setStoremanID(response.data?.storeman?.id ?? '');
            setLoading(false);    
        })
        .catch((err) => {
            console.log(err)
            if(err.response.status === 401){
                if(err.response.data.logout){
                    navigate('/login');
                }
                else{
                    window.alert(err.response.data.message)
                }
            }
        })
    }

    const editProjectContractorData = (e) => {
        
        e.stopPropagation();
        e.preventDefault();
        
        setSending(true);
        const putJSON = {
            main_contractor_id: mainContractorID === '' ? null : parseInt(mainContractorID),
            account_contact_id: accContactID === '' ? null : parseInt(accContactID),
            foreman_id: foremanID === '' ? null : parseInt(foremanID),
            safety_officer_id: sftyOffID === '' ? null : parseInt(sftyOffID),
            storeman_id: storemanID === '' ? null : parseInt(storemanID),
        }

        ProjectAPIs.PutProjectMainContractorEmployees(params.ProjectID, putJSON)
        .then((response) => {
            if(response.status === 200){
                getProjectContractorData(params.ProjectID);
                setEditing(false);
                setSending(false);
                addToast({ message: "Contractor Contacts updated successfully!", variant: "success", autoHide: true });
            }
        })
        .catch((err) => {
            console.log(err)
            setSending(false);
            ApiResponseHandler(err.response);
        })
        
    }

    const handleCancel = () => {
        setMainContractorID(contractorData?.company?.id ?? '');
        setAccContactID(contractorData?.accountContact?.id ?? '');
        setForemanID(contractorData?.foreman?.id ?? '');
        setSftyOffID(contractorData?.safetyOfficer.id ?? '');
        setStoremanID(contractorData?.storeman?.id ?? '');
        setEditing(false);
    }

    const handleChangeCompany = (e) => {
        setMainContractorID(e.target.value);
        setAccContactID('');
        setForemanID('');
        setSftyOffID('');
        setStoremanID('');
    }

    const getEmployees = () => {
        CompanyAPIs.GetCompanyEmployees(contractorData.company.id)
        .then((response) => {
            console.log(response.data);
            setEmployees(response.data);
        })
        .catch((err) => {
            ApiResponseHandler(err.response, navigate);
        })
    }

    useEffect(() => {
        getProjectContractorData(params.ProjectID);
    }, [params.ProjectID])

    useEffect(() => {
        if(contractorData.company){
            console.log('here');
            getEmployees();
        }
    }, [contractorData, params.projectID])

    if(loading){
        return(
            <div>Loading...</div>
        )
    }
    else {
        return(
            <div className="project-section">
                <Form onSubmit={editProjectContractorData}>
                    
                    <div className="project-section-header">
                            <h4 className="section-title">
                                {editing ? 
                                    <DropDown.AllCompanies className={'editable-field'} value={mainContractorID} onChange={handleChangeCompany} />
                                    :
                                    contractorData?.company?.name ?? ''}
                            </h4>
                            <div className="project-header-actions">
                                <button
                                    disabled={sending || !editing}
                                    type="submit"
                                    className="save-btn"
                                    style={editing ? {display: 'block'} : {display: 'none'}}
                                >
                                    {sending ? 'Saving...' : 'Save'}
                                </button>

                                {editing ? (
                                    <button
                                        disabled={sending}
                                        type="button"
                                        className="cancel-btn"
                                        onClick={handleCancel}
                                    >
                                        Cancel
                                    </button>
                                ) : (
                                    <button
                                        disabled={sending}
                                        type="button"
                                        className="edit-btn"
                                        onClick={() => setEditing(true)}
                                    >
                                        <MdEdit /> Edit
                                    </button>
                                )}
                            </div>
                    </div>
                    <div className="project-section-body">

                    
                        {editing ? 
                            
                            <div className="project-section-body-item">
                                <div className="view-contractor-employee-container">
                                    <div>
                                     <span className="label">Account Contact</span>
                                    <DropDown.CompanyEmployees 
                                            companyID={mainContractorID} 
                                            value={accContactID} 
                                            onChange={(e) => setAccContactID(e.target.value)}
                                            disabled={!editing}
                                            className={'editable-field'}
                                        />
                                    </div>
                                   
                                    <div>
                                        <ViewProjectContractorEmployee employeeID={accContactID}/>
                                    </div>
                                    
                                </div>

                               
                            
                            </div>
                            :
                            <div className="project-section-body-item">
                                <div className='view-contractor-employee-container'>
                                    <div>
                                        <span className="label">Account Contact</span>
                                        <div>
                                            {(employees.find((emp) => emp.id === contractorData.accountContact?.id ?? null)?.first_name ?? '') + ' ' + (employees.find((emp) => emp.id === contractorData.accountContact?.id ?? null)?.last_name ?? '')}
                                        </div>
                                   </div>
                                    <div>
                                        <ViewProjectContractorEmployee employeeID={accContactID}/>
                                    </div>
                                    
                                </div>
                                
                            </div>
                        }
                           

                
                                    {editing ? 
                                        
                                        <div className="project-section-body-item">
                                            <div className="view-contractor-employee-container">
                                                <div>
                                                    <span className="label">Foreman</span>
                                                    <DropDown.CompanyEmployees 
                                                        companyID={mainContractorID} 
                                                        value={foremanID} 
                                                        onChange={(e) => setForemanID(e.target.value)}
                                                        disabled={!editing}
                                                        className={'editable-field'}
                                                        
                                                    />
                                                </div>
                                                <ViewProjectContractorEmployee employeeID={foremanID}/>
                                            </div>
                                        </div>
                                        :
                                        <div className="project-section-body-item">
                                            <div className="view-contractor-employee-container">
                                            <div>
                                            <span className="label">Foreman</span>
                                            <div>
                                                {(employees.find((emp) => emp.id === contractorData.foreman?.id ?? null)?.first_name ?? '') + ' ' + (employees.find((emp) => emp.id === contractorData.foreman?.id ?? null)?.last_name ?? '')}
                                            </div>
                                            </div>
                                            <ViewProjectContractorEmployee employeeID={foremanID}/>
                                            </div>
                                        </div>}
                                        
                
                                    {editing ? 
                                        
                                        <div className="project-section-body-item">
                                            <div className="view-contractor-employee-container">
                                                <div>
                                                <span className="label">Safety Officer</span>
                                                <DropDown.CompanyEmployees 
                                                    companyID={mainContractorID} 
                                                    value={sftyOffID} 
                                                    onChange={(e) => setSftyOffID(e.target.value)}
                                                    disabled={!editing}
                                                    className={'editable-field'}
                                                   
                                                />
                                                </div>
                                                <ViewProjectContractorEmployee employeeID={sftyOffID}/>
                                            </div>
                                        </div>
                                        :
                                        <div className="project-section-body-item">
                                            <div className="view-contractor-employee-container">
                                                <div>
                                                    <span className="label">Safety Officer</span>
                                                    <div>
                                                        {(employees.find((emp) => emp.id === contractorData.safetyOfficer?.id ?? null)?.first_name ?? '') + ' ' + (employees.find((emp) => emp.id === contractorData.safetyOfficer?.id ?? null)?.last_name ?? '')}
                                                    </div>
                                                </div>
                                                <ViewProjectContractorEmployee employeeID={sftyOffID}/>
                                            </div>
                                        </div>
                                    }
               
                                    {editing ? 
                                        
                                        <div className="project-section-body-item">
                                            <div className="view-contractor-employee-container">
                                                <div>
                                                <span className="label">Storeman</span>
                                                <DropDown.CompanyEmployees 
                                                        companyID={mainContractorID} 
                                                        value={storemanID} 
                                                        onChange={(e) => setStoremanID(e.target.value)}
                                                        disabled={!editing}
                                                        className={'editable-field'}
                                                        
                                                    />
                                                </div>
                                                <ViewProjectContractorEmployee employeeID={storemanID}/>
                                            </div>
                                        </div>
                                        :
                                        <div className="project-section-body-item">
                                            <div className="view-contractor-employee-container">
                                                <div>
                                                    <span className="label">Storeman</span>
                                                    <div>
                                                        {(employees.find((emp) => emp.id === contractorData.safety_officer_id)?.first_name ?? '') + ' ' + (employees.find((emp) => emp.id === contractorData.safety_officer_id)?.last_name ?? '')}
                                                    </div>
                                                </div>
                                                <ViewProjectContractorEmployee employeeID={storemanID}/>
                                            </div>
                                        </div>
                                        }
                                       

                            
                        

                            
                                
                            

                            
                                
                            

                            
                                

                    </div>

                    


                
                    
                
                

                {/* <div className='m-1'>
                    <div  className="project-section">
                        <div className="project-section-header">
                            <h5 className="section-title">Account Contact</h5>
                        </div>
                        
                        <div >
                        {editing ? 
                            
                            <div>
                            <DropDown.CompanyEmployees 
                                    companyID={mainContractorID} 
                                    value={accContactID} 
                                    onChange={(e) => setAccContactID(e.target.value)}
                                    disabled={!editing}
                                    className={'editable-field'}
                                    required
                                />
                            <ViewProjectContractorEmployee employeeID={accContactID}/>
                            </div>
                            :
                            <div>
                                <div>
                                    {(employees.find((emp) => emp.id === contractorData.account_contact_id)?.first_name ?? '') + ' ' + (employees.find((emp) => emp.id === contractorData.account_contact_id)?.last_name ?? '')}
                                </div>
                                <ViewProjectContractorEmployee employeeID={accContactID}/>
                            </div>}
                            </div>
                            
                    </div>
                </div>

                <div className='m-1'>
                    <div  className="project-section">
                                    <div className="project-section-header">
                                        <h5 className="section-title">Foreman</h5>
                                    </div>
                                    
                                    <div >
                                    {editing ? 
                                        
                                        <div>
                                        <DropDown.CompanyEmployees 
                                                companyID={mainContractorID} 
                                                value={foremanID} 
                                                onChange={(e) => setForemanID(e.target.value)}
                                                disabled={!editing}
                                                className={'editable-field'}
                                                required
                                            />
                                        <ViewProjectContractorEmployee employeeID={foremanID}/>
                                        </div>
                                        :
                                        <div>
                                            <div>
                                                {(employees.find((emp) => emp.id === contractorData.foreman_id)?.first_name ?? '') + ' ' + (employees.find((emp) => emp.id === contractorData.foreman_id)?.last_name ?? '')}
                                            </div>
                                            <ViewProjectContractorEmployee employeeID={foremanID}/>
                                        </div>}
                                        </div>
                                        
                                </div>
                </div>
                <div className='m-1'>
                    <div  className="project-section">
                                    <div className="project-section-header">
                                        <h5 className="section-title">Safety Officer</h5>
                                    </div>
                                    
                                    <div >
                                    {editing ? 
                                        
                                        <div>
                                        <DropDown.CompanyEmployees 
                                                companyID={mainContractorID} 
                                                value={sftyOffID} 
                                                onChange={(e) => setSftyOffID(e.target.value)}
                                                disabled={!editing}
                                                className={'editable-field'}
                                                required
                                            />
                                        <ViewProjectContractorEmployee employeeID={sftyOffID}/>
                                        </div>
                                        :
                                        <div>
                                            <div>
                                                {(employees.find((emp) => emp.id === contractorData.safety_officer_id)?.first_name ?? '') + ' ' + (employees.find((emp) => emp.id === contractorData.safety_officer_id)?.last_name ?? '')}
                                            </div>
                                            <ViewProjectContractorEmployee employeeID={sftyOffID}/>
                                        </div>}
                                        </div>
                                        
                                </div>
                </div>
                <div className='m-1'>
                                        <div  className="project-section">
                                    <div className="project-section-header">
                                        <h5 className="section-title">Storeman</h5>
                                    </div>
                                    
                                    <div>
                                    {editing ? 
                                        
                                        <div>
                                        <DropDown.CompanyEmployees 
                                                companyID={mainContractorID} 
                                                value={storemanID} 
                                                onChange={(e) => setStoremanID(e.target.value)}
                                                disabled={!editing}
                                                className={'editable-field'}
                                                required
                                            />
                                        <ViewProjectContractorEmployee employeeID={sftyOffID}/>
                                        </div>
                                        :
                                        <div>
                                            <div>
                                                {(employees.find((emp) => emp.id === contractorData.safety_officer_id)?.first_name ?? '') + ' ' + (employees.find((emp) => emp.id === contractorData.safety_officer_id)?.last_name ?? '')}
                                            </div>
                                            <ViewProjectContractorEmployee employeeID={sftyOffID}/>
                                        </div>}
                                        </div>
                                        
                                </div>
                </div> */}
                </Form>
            </div>
        )
    }
}